import React from 'react';
import { Container, Row, Col } from '@everlywell/leaves';

import SectionWrapper from 'components/SectionWrapper';

import * as S from './styles';

interface Props {
  backgroundColor: string;
  slug: string;
  title: string;
  headline: string;
  description: string;
}

export const TestimonialSection: React.FC<Props> = ({
  slug,
  backgroundColor,
  title,
  headline,
  description,
}: Props) => {
  return (
    <SectionWrapper
      data-testid={slug || 'testimonialSection'}
      id={slug}
      backgroundColor={backgroundColor}
    >
      <Container>
        <Row>
          <Col xs>
            <S.Wrapper>
              <S.Description>{description}</S.Description>
              <S.Title>{title}</S.Title>
              <S.Title>{headline}</S.Title>
            </S.Wrapper>
          </Col>
        </Row>
      </Container>
    </SectionWrapper>
  );
};

export default TestimonialSection;
